import {
  TableFooter,
  TableRow,
  TableCell,
  Typography,
  Select,
  Pagination,
  PaginationPropsType,
} from '@astro-ui/components'
import styled from 'styled-components'

const pageLimitOptions = [{ value: 10 }, { value: 20 }, { value: 30 }]

export type PageSizeOptionsType = {
  value: number
}
export type TableFooterPaginationPropsType = Omit<PaginationPropsType, 'onClick'> & {
  customPageLimitOptions?: PageSizeOptionsType[]
  onChangePageSize: (selected: PageSizeOptionsType) => void
  onClickBtnPage: (page: number) => void
  // eslint-disable-next-line react/no-unused-prop-types
  customColSpan?: number
  // eslint-disable-next-line react/no-unused-prop-types
  sticky?: boolean
}

const TableFooterPagination = ({
  pageIndex,
  pageSize,
  numberOfElements,
  customPageLimitOptions,
  onChangePageSize,
  onClickBtnPage,
  customColSpan = 11,
  firstPage,
  sticky = true,
}: TableFooterPaginationPropsType) => (
  <S.TableFooterSticky sticky={sticky}>
    <TableRow>
      <TableCell colSpan={customColSpan}>
        <BaseTablePagination
          pageIndex={pageIndex}
          pageSize={pageSize}
          numberOfElements={numberOfElements}
          customPageLimitOptions={customPageLimitOptions}
          onChangePageSize={onChangePageSize}
          onClickBtnPage={onClickBtnPage}
          firstPage={firstPage}
        />
      </TableCell>
    </TableRow>
  </S.TableFooterSticky>
)
export const BaseTablePagination = ({
  pageIndex,
  pageSize,
  numberOfElements,
  customPageLimitOptions,
  onChangePageSize,
  onClickBtnPage,

  firstPage,
}: TableFooterPaginationPropsType) => (
  <S.WrapperTablePagination>
    <S.WrapperLimitCombobox>
      <Select
        required
        displayKey="value"
        value={pageSize.toString()}
        options={customPageLimitOptions || pageLimitOptions}
        onChange={onChangePageSize}
      />
      <Typography variant="body2" marginLeft="10px" fontWeight="bold">
        Tiap halaman
      </Typography>
    </S.WrapperLimitCombobox>
    <Pagination
      pageIndex={pageIndex}
      pageSize={pageSize}
      numberOfElements={numberOfElements}
      onClick={onClickBtnPage}
      firstPage={firstPage}
    />
  </S.WrapperTablePagination>
)

export default TableFooterPagination

const S = {
  TableFooterSticky: styled(TableFooter)<{ sticky?: boolean }>`
    width: 100%;
    position: ${({ sticky }) => (sticky ? 'sticky' : 'static')};
    bottom: 0;
    z-index: ${({ sticky }) => (sticky ? 1 : 'auto')};
    background-color: white;
  `,
  WrapperTablePagination: styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
  `,
  WrapperLimitCombobox: styled.div`
    display: flex;
    align-items: center;
  `,
}
